'use client'

import { use } from 'react'

import Swimlane, { SwimlaneSkeleton } from '@/app/[locale]/(worlds)/components/Swimlane'
import { ViverseWorldCardSkeleton } from '@/components/ViverseWorldCardSkeleton'
import { CARD_CLASS_SWIMLANE } from '@/constants/card'
import { SWIMLANE_DEFAULT_CONTENT_INSET_CLASS } from '@/constants/swimlane'
import { useConfigsContext } from '@/context/ConfigsContext'
import { cn } from '@/lib/utils'
import type { Room } from '@/services/cms'

const EXPERIENCE_OVERFLOW_FIX = '-mb-8 pt-2 pb-10' as const

type BIRecommendedWorldsSectionProps = {
  worldsPromise: Promise<Room[]>
  title: string
}

export default function BIRecommendedWorldsSection({
  worldsPromise,
  title,
}: BIRecommendedWorldsSectionProps) {
  const { store } = useConfigsContext()
  const htcToken = store?.credentials?.htcToken
  const rooms = use(worldsPromise)

  if (!rooms || rooms.length === 0) return null

  return (
    <Swimlane
      data-section="recommended-worlds"
      className="lg:gap-0"
      title={title}
      cardVariant="viverse"
      rooms={rooms}
      dataRoomIdPrefix="bi"
      rawCardType
      hideLiked={!htcToken}
      hidePremiumBadge={false}
      scrollClassName={cn(
        'no-scrollbar flex w-full flex-1 gap-2 overflow-x-auto select-none md:gap-4',
        EXPERIENCE_OVERFLOW_FIX,
      )}
    />
  )
}

export function BIRecommendedWorldsSectionSkeleton() {
  return (
    <SwimlaneSkeleton showTitleAction={false}>
      <div
        className={cn(
          'no-scrollbar flex w-full flex-1 gap-2 overflow-x-auto md:gap-4',
          EXPERIENCE_OVERFLOW_FIX,
          SWIMLANE_DEFAULT_CONTENT_INSET_CLASS,
        )}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <ViverseWorldCardSkeleton key={`skeleton-${index}`} className={CARD_CLASS_SWIMLANE} />
        ))}
      </div>
    </SwimlaneSkeleton>
  )
}
